import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {retry} from 'rxjs/operators';
import {ConfigUtil} from '@shared/services/config.util';

@Injectable({
  providedIn: 'root'
})
export class HeartBeatApi {
  private readonly httpClient = inject(HttpClient);

  private readonly endpoint: string;

  constructor() {
    this.endpoint = `${ConfigUtil.get('api')['backend']}`;
  }

  public beat(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.endpoint}/heartbeat`).pipe(
      retry(0)
    );
  }
}
